export default {
  name: 'Editor',
  path: '/editor',
  meta: {
    title: 'momo the cat video editor'
  }
};
